import { render, staticRenderFns } from "./CertificateRow.vue?vue&type=template&id=15d12c4e&scoped=true&"
import script from "./CertificateRow.vue?vue&type=script&lang=ts&"
export * from "./CertificateRow.vue?vue&type=script&lang=ts&"
import style0 from "./CertificateRow.vue?vue&type=style&index=0&id=15d12c4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d12c4e",
  null
  
)

export default component.exports